export default {
    updateFormData(state, formData) {
        state.formData = formData;
    },
    updateGymMembershipData(state, data) {
        state.gymMembershipData = data;
    },
    updateSummary(state, data) {
        state.formSummary = data;
    },
    updateFormConditionals(state, data) {
        state.formConditionals = data;
    },
    updateIsLoading(state, boolean) {
        state.isLoading = boolean;
    }
}